import { DataTableCol } from "../../../components/tables/types";

export const projectDataGridCols: DataTableCol[] = [
    {
        title: 'Created Date',
        control: 'createdAt',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Name',
        control: 'name',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Batch Name',
        control: 'userBatchName',
        sortable: true,
        canShowColumn: true
    },
   
    {
        title: 'Domain',
        control: 'courseName',
        sortable: true,
        canShowColumn: true
    },
    
    {
        title: 'Project Name',
        control: 'projectName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Upload Files',
        control: 'projectUpload',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: false,
        isDelete: true,
        canShowColumn: true,
    },
];